import { ImageIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface ReservedImageSlotProps {
  src: string;
  alt: string;
  aspect?: string;
  slotLabel: string;
  className?: string;
  priority?: boolean;
}

export const ReservedImageSlot = ({
  src,
  alt,
  aspect = "aspect-[4/5]",
  slotLabel,
  className,
  priority = false,
}: ReservedImageSlotProps) => {
  const displaySrc = src.includes("/images/bath/") ? `${src}?v=bath-aligned-20260503` : src;

  return (
    <div
      className={cn(
        "relative overflow-hidden bg-neutral-100",
        "border border-neutral-200",
        aspect,
        className
      )}
    >
      <img
        src={displaySrc}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).style.display = "none";
          const ph = e.currentTarget.nextElementSibling as HTMLElement | null;
          if (ph) ph.style.display = "flex";
        }}
      />

      <div
        className="absolute inset-0 hidden flex-col items-center justify-center gap-3 p-6 text-center"
        aria-hidden="true"
      >
        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-amber-500/40 bg-amber-50">
          <ImageIcon className="h-5 w-5 text-amber-600" />
        </div>
        <p className="font-serif text-sm tracking-wide text-neutral-700">
          Product Image — Coming Soon
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-400">
          Slot: {slotLabel}
        </p>
      </div>
    </div>
  );
};

export default ReservedImageSlot;
